import axios from "axios";

const baseDomain = 'https://api.ip-bid.com'
 
const baseURL = `${baseDomain}/api`;

export default axios.create({
	baseURL
});
